import { AbsoluteFill, Sequence } from "remotion";
import { SCENE, COLORS } from "./constants";
import { Scene1Query } from "./Scene1Query";
import { Scene2Scanning } from "./Scene2Scanning";
import { Scene3Answer } from "./Scene3Answer";
import { Scene4Sources } from "./Scene4Sources";
import { Scene6TrustIntro } from "./Scene6TrustIntro";
import { Scene7Grounded } from "./Scene7Grounded";
import { Scene8Citations } from "./Scene8Citations";
import { Scene9Diagrams } from "./Scene9Diagrams";
import { Scene10Cost } from "./Scene10Cost";
import { Scene5Punchline } from "./Scene5Punchline";

export const EAKC30SecDemo: React.FC = () => {
  return (
    <AbsoluteFill style={{ backgroundColor: COLORS.bg }}>
      <Sequence from={SCENE.query.start}      durationInFrames={SCENE.query.duration}><Scene1Query /></Sequence>
      <Sequence from={SCENE.scanning.start}   durationInFrames={SCENE.scanning.duration}><Scene2Scanning /></Sequence>
      <Sequence from={SCENE.answer.start}     durationInFrames={SCENE.answer.duration}><Scene3Answer /></Sequence>
      <Sequence from={SCENE.sources.start}    durationInFrames={SCENE.sources.duration}><Scene4Sources /></Sequence>
      {/* Trust & quality upgrades — build-log intro + four before→after cards */}
      <Sequence from={SCENE.trustIntro.start} durationInFrames={SCENE.trustIntro.duration}><Scene6TrustIntro /></Sequence>
      <Sequence from={SCENE.grounded.start}   durationInFrames={SCENE.grounded.duration}><Scene7Grounded /></Sequence>
      <Sequence from={SCENE.citations.start}  durationInFrames={SCENE.citations.duration}><Scene8Citations /></Sequence>
      <Sequence from={SCENE.diagrams.start}   durationInFrames={SCENE.diagrams.duration}><Scene9Diagrams /></Sequence>
      <Sequence from={SCENE.cost.start}       durationInFrames={SCENE.cost.duration}><Scene10Cost /></Sequence>
      <Sequence from={SCENE.punchline.start}  durationInFrames={SCENE.punchline.duration}><Scene5Punchline /></Sequence>
    </AbsoluteFill>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
